import styled from "styled-components";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { baseUrl } from "../config";
import { ListContainer } from "./styles";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { MaterialReactTable } from "material-react-table";
import { summarizeTimelineFilters } from "../utils/timelineFilterSummary";

const MeTimelines = () => {
  const navigate = useNavigate();
  const [timelines, setTimelines] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 20 });
  const [columnFilters, setColumnFilters] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [categoryMap, setCategoryMap] = useState({});

  useEffect(() => {
    axios
      .get(baseUrl + "/event-categories")
      .then((res) => {
        const next = {};
        (res.data || []).forEach((cat) => {
          next[String(cat.id)] = cat.name;
        });
        setCategoryMap(next);
      })
      .catch(() => {});
  }, []);

  const fetchMyTimelines = async (pageIndex, pageSize, columnFilters) => {
    try {
      const params = {
        page: pageIndex + 1,
        pageSize,
      };
      if (columnFilters && columnFilters.length) {
        columnFilters.forEach((f) => {
          params[f.id] = f.value;
        });
      }
      // After column filters: MRT can set authorPseudo to "" / undefined when clearing filters,
      // which would drop "me" and list everyone's frises.
      params.authorPseudo = "me";
      const res = await axios.get(baseUrl + "/timelines", {
        withCredentials: true,
        params,
      });
      setTimelines(res.data.data || []);
      setRowCount(res.data.total || 0);
    } catch (err) {
      console.error("Error fetching my timelines:", err);
    }
  };

  useEffect(() => {
    fetchMyTimelines(pagination.pageIndex, pagination.pageSize, columnFilters);
  }, [pagination, columnFilters]);

  const columns = [
    {
      accessorKey: "name",
      header: "Nom",
      size: 300,
      grow: 1,
      filterVariant: "text",
    },
    {
      accessorKey: "description",
      header: "Description",
      size: 400,
      grow: 1,
      filterVariant: "text",
    },
    {
      accessorKey: "filters",
      header: "Filtrage",
      size: 450,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 450,
          }}
          title={summarizeTimelineFilters(row.original.filters, categoryMap, 500)}
        >
          {summarizeTimelineFilters(row.original.filters, categoryMap, 120)}
        </div>
      ),
    },
  ];

  return (
    <MeContainer>
      <h1>Mes frises</h1>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        component={Link}
        to="/add-timeline"
        sx={{ alignSelf: "flex-start", mb: 2 }}
      >
        Créer une frise
      </Button>
      <TableWrapper>
        <MaterialReactTable
          columns={columns}
          data={timelines}
          muiTableBodyRowProps={({ row }) => ({
            onClick: () => navigate(`/timelines/${row.original.id}`),
            sx: { cursor: "pointer" },
          })}
          enableColumnOrdering
          enableColumnResizing
          enableColumnActions={false}
          enableHiding={false}
          enableSorting
          manualPagination
          manualFiltering
          rowCount={rowCount}
          state={{ pagination, columnFilters }}
          onPaginationChange={setPagination}
          onColumnFiltersChange={setColumnFilters}
          initialState={{ density: "compact" }}
          muiTableBodyCellProps={{ sx: { verticalAlign: "middle" } }}
          muiTableHeadCellProps={{ sx: { verticalAlign: "middle" } }}
        />
      </TableWrapper>
    </MeContainer>
  );
};

export default MeTimelines;

const MeContainer = styled(ListContainer)`
  max-width: 100vw;
  width: 100%;
  margin: 0 auto;
  padding: 0 10px;
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
`;
